package app.bloomey.web.modules.library

import app.bloomey.web.core.data.models.*
import app.bloomey.web.utils.bodySuccess
import io.ktor.client.*
import io.ktor.client.request.*
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

class LibraryApi : KoinComponent {
    private val client by inject<HttpClient>()
    suspend fun getLibraries(page: Int, size: Int, query: String): ApiResponse<PageResponse<List<Category>>> {
        val response = client.get("v1/video/admin/categories") {
            parameter("page", page)
            parameter("size", size)
            parameter("query", query)
        }
        return response.bodySuccess()
    }

    suspend fun getCategoryVideos(categoryId: String, page: Int, size: Int): PageResponse<List<Video>> {
        val response = client.get("v1/video/admin/category/$categoryId/videos") {
            parameter("page", page)
            parameter("size", size)
        }
        return response.bodySuccess<ApiResponse<PageResponse<List<Video>>>>().data
    }

    suspend fun deleteLibrary(id: String): ApiResponse<Boolean> {
        val response = client.delete("v1/video/admin/category/$id")
        return response.bodySuccess()
    }

    suspend fun updateLibrary(id: String, request: CategoryUpdateRequest): ApiResponse<Boolean> {
        val response = client.patch("v1/video/admin/category/$id") {
            setBody(request)
        }
        return response.bodySuccess()
    }
}